function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { get, AuthenticationTypes } from '@shared/services/http/httpProtocol';
import { logError } from '@shared/utils/httpClientUtil';
const commonHttpOptions = {
    requireCorrelationId: true,
    stringifyPostData: false,
    authenticationType: AuthenticationTypes.Unauthenticated,
    setBearerHeader: false
};
export const AppReviewsQueryStrings = {
    OfferId: 'offer_Id',
    ApiVersion: 'api-version',
    Source: 'source',
    FilterEmptyTitles: 'filter_empty_titles'
};
/*
 * Gets reviews for a given offer Id
 * @param Object containing named parameters for the call
 * @returns Promise with the response, containing the reviews for the offer
 */ export function getAppReviews(_0) {
    return _async_to_generator(function*({ entityId, reviewsAPI, reviewsAPIVersion }) {
        try {
            if (!entityId) {
                logError('reviewAppReviewsRestClient.getAppReviews - AppId is empty');
                return Promise.reject(new Error('AppId is required'));
            }
            return yield get(`${reviewsAPI}`, commonHttpOptions).addQueryEntry(AppReviewsQueryStrings.ApiVersion, reviewsAPIVersion).addQueryEntry(AppReviewsQueryStrings.OfferId, entityId).addQueryEntry(AppReviewsQueryStrings.FilterEmptyTitles, 'true').request();
        } catch (error) {
            logError('reviewAppReviewsRestClient.getAppReviews', error);
            return Promise.reject(error);
        }
    }).apply(this, arguments);
}
